module.exports = __webpack_public_path__ + "img/h2.01789d09.jpg";